import './index.scss';
import Loader from 'react-loaders';
import AnimatedLetters from '../AnimatedLetters';
import { useState} from 'react';
import ProjectDiv from './ProjectDiv';

import calculator from '../../assets/images/project-logos/calculator.png'
import cardGame from '../../assets/images/project-logos/cardGame.png'
import bot from '../../assets/images/project-logos/hermesBot.png'
import rhymeVerse from '../../assets/images/project-logos/rhymeVerse.png'
import speedChecker from '../../assets/images/project-logos/speedChecker.png'
import todoApp from '../../assets/images/project-logos/todoApp.png'
import urlShortener from '../../assets/images/project-logos/urlShortener.png'
import weatherApp from '../../assets/images/project-logos/weatherApp.png'
import soogle from '../../assets/images/project-logos/soogle.png'
import chef from '../../assets/images/project-logos/chef.png'
import banerjee from '../../assets/images/project-logos/banerjee.png'
import platformer from '../../assets/images/project-logos/platformer.png'
import nftMinter from '../../assets/images/project-logos/nftMinter.png'
import navigator from '../../assets/images/project-logos/navigator.png'
import chat from '../../assets/images/project-logos/chat.png'

const Projects = () => {

    const [letterClass, setLetterClass] = useState('text-animate');

    setTimeout(() => {
        setLetterClass('text-animate-hover');
    }, 3000);

    document.title = "Portfolio | Projects";
    
    return(
        <>
        <div className="projects-page">
            <div className="text-top">
                <h1>
                    <AnimatedLetters letterClass={letterClass} myStr={"My"} idx={3} />{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Projects"} idx={4} />
                </h1>
                <hr />
            </div>
            <div className="projects-zone">
                <div className="projects-list space-y-6">
                    <ProjectDiv text={"Soogle - Google Clone"} link={"https://soogle-search-soumya.netlify.app/"} logo={soogle} index={0}/>
                    <ProjectDiv text={"Hermes Chat-bot AI"} link={"https://hermes-bay.vercel.app/"} logo={bot} index={1}/>
                    <ProjectDiv text={"Weather App"} link={"https://weather19.anvil.app/"} logo={weatherApp} index={2}/>
                    <ProjectDiv text={"Banerjee Tours & Travels"} link={"https://banerjeetravels.github.io/banerjee-tours-travels/"} logo={banerjee} index={3}/>
                    <ProjectDiv text={"Platformer Game"} link={"https://platformer-soumya.netlify.app/"} logo={platformer} index={4}/>
                    <ProjectDiv text={"NFT Candy Machine"} link={"https://anime-nft-minter.netlify.app/"} logo={nftMinter} index={5}/>
                    <ProjectDiv text={"S-Chat App"} link={"https://schat-soumya19.netlify.app/"} logo={chat} index={6}/>
                    <ProjectDiv text={"Recipe App"} link={"https://khai-khai-singlepage.netlify.app/"} logo={chef} index={7}/>
                    <ProjectDiv text={"Path Finding Visualizer"} link={"https://path-finding-visualizer-19.netlify.app/"} logo={navigator} index={8}/>
                    <ProjectDiv text={"Rhyming word generator"} link={"https://word-verse007.anvil.app/"} logo={rhymeVerse} index={9}/>
                    <ProjectDiv text={"URL Shortener"} link={"https://soumya-ly.onrender.com"} logo={urlShortener} index={10}/>
                    <ProjectDiv text={"Flip-the-card Game"} link={"https://flip-the-card-soumya.onrender.com"} logo={cardGame} index={11}/>
                    <ProjectDiv text={"Todos App"} link={"https://todos-flask19.onrender.com"} logo={todoApp} index={12}/>
                    <ProjectDiv text={"Typing Speed Checker"} link={"https://speed-x.onrender.com"} logo={speedChecker} index={13}/>
                    <ProjectDiv text={"Calculator App"} link={"https://calculator-69.anvil.app/"} logo={calculator} index={14}/>
                </div>
            </div>
        </div>
        <Loader type="ball-spin-fade-loader" />
        </>
    );
}

export default Projects;